import * as React from 'react'
import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import styled from 'styled-components'
import { Container, Col, Row, config } from 'react-awesome-styled-grid'
import HtmlHead from '@components/HtmlHead'
import type { AppStateType } from '../../reducers/appstate'
import { withRouter } from 'next/router'
import { GlobalStyle, colors, H1, P, H2 } from '@components/shared'
import TopNav from '@components/TopNav'
import { AnchorCTA } from '@components/shared/buttons'
import TrackClipSlider from '@components/TrackClipSlider'
import DriveToDownloadBlock from '@components/DriveToDownloadBlock'
import Footer from '@components/Footer'
import TopNavMobile from '@components/TopNavMobile'

function Index (): React.ReactNode {
  return (
    <>
      <HtmlHead
        title={'Dipsea | Voice Act for Dipsea'}
        description={'Our short, sexy audio stories are made possible by talented people - actors and non-actors alike. See what we\'re looking for and submit your audtion for Dipsea.'}
      />
      <GlobalStyle backgroundColor={colors.midnightBlue}/>
      <VoiceContainer>
        <TopNav backgroundColor={colors.midnightBlue95} isAssetLoaded={true}/>
        <TopNavMobile backgroundColor={colors.midnightBlue95} isAssetLoaded={true}/>
        <Container>
          <Row align="center" justify="center">
            <Col>
              <TitleH1 textAlign="center">Voice act for Dipsea</TitleH1>
              <Description>Our short, sexy audio stories are made possible by talented actors. Imagine the monologues and dialogues of popular TV shows, done exclusively in audio.</Description>
              <AuditionBtnContainer>
                <AnchorCTA target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSdjO1-ouXfgiVMMUfjbLPvxn4jilz6KlmywoHefDn617gPxJg/viewform">Audition now</AnchorCTA>
              </AuditionBtnContainer>
            </Col>
          </Row>
          <Row align="center" justify="center">
            <Col>
              <VoiceH2 textAlign="center" color={colors.sand} styles={{ marginBottom: '20px' }}>We're looking for...</VoiceH2>
              <DescriptionWithDots>•  Voices that sound 20–50 years old<br />•  Trained actors<br />•  Accents welcome</DescriptionWithDots>
              <AuditionBtnContainer2>
                <AnchorCTA target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSdjO1-ouXfgiVMMUfjbLPvxn4jilz6KlmywoHefDn617gPxJg/viewform">Audition now</AnchorCTA>
              </AuditionBtnContainer2>
            </Col>
          </Row>
        </Container>
      </VoiceContainer>
      <TakeAListenContainer>
        <Container>
          <Row align={{ sm: 'center', lg: 'flex-start' }}>
            <Col sm={8} md={8} lg={5} xl={6} align="center" justify="center">
              <TrackTextContainer>
                <VoiceH2a>Take a listen</VoiceH2a>
                <Description2>Listen to these clips to get a feel for our style before you audition. The number one thing we listen for is believability–we want it to sound like you're a real person experiencing real emotions.</Description2>
                <TrackTextButton target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSdjO1-ouXfgiVMMUfjbLPvxn4jilz6KlmywoHefDn617gPxJg/viewform">Audition now</TrackTextButton>
              </TrackTextContainer>
            </Col>
            <Col sm={8} md={8} lg={7} xl={6}>
              <SliderWrapper>
                <TrackClipSlider slides={[
                  {
                    mp3Url: '/mp3s/wild-hearts-i.mp3',
                    title: 'Wild Hearts',
                    img: 'Wild-Hearts',
                    tags: 'Her + Her',
                    startTime: 263,
                    endTime: 523,
                    duration: 11
                  },
                  {
                    mp3Url: '/mp3s/off-the-record-i.mp3',
                    title: 'Off The Record I',
                    img: 'Off-The-Record',
                    tags: 'Her + Him',
                    startTime: 241,
                    endTime: 721,
                    duration: 16
                  },
                  {
                    mp3Url: '/mp3s/eighty-six-i.mp3',
                    title: 'Eighty Six',
                    img: 'Eighty-Six',
                    tags: 'Her + Him',
                    startTime: 192,
                    endTime: 430,
                    duration: 11
                  },
                  {
                    mp3Url: '/mp3s/giw-james.mp3',
                    title: 'Get Intimate With James',
                    img: 'GIW-James',
                    tags: 'Him + You',
                    startTime: 101,
                    endTime: 593,
                    duration: 20
                  },
                  {
                    mp3Url: '/mp3s/swipe-right-v.mp3',
                    title: 'Swipe Right',
                    img: 'Swipe-Right-V',
                    tags: 'Her + Her + Him',
                    startTime: 214,
                    endTime: 418,
                    duration: 21
                  }
                ]} />
              </SliderWrapper>
            </Col>
          </Row>
          <Row align="center" justify="center">
            <Col align="center" justify="center">
              <D2DWrapper>
                <DriveToDownloadBlock />
              </D2DWrapper>
            </Col>
          </Row>
        </Container>
      </TakeAListenContainer>
      <Footer />
    </>
  )
}

const mapStateToProps = (_state: AppStateType): any => {
  return {
  }
}

const mapDispatchToProps = (_dispatch: Dispatch<any>): any => {
  return {}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Index) as any) as any

const D2DWrapper = styled.div<any>`
  ${(props: any): any => config(props).media.lg`
    margin-top: 16px;
  `}
  ${(props: any): any => config(props).media.xl`
    margin-top: 35px;
  `}
`
const VoiceContainer = styled.main<any>`
  background: url('/images/Voice-Actor-Dusk-Mobile.jpg') no-repeat;
  background-size: cover;
  background-color: ${colors.cobalt};
  padding: 0;
  ${(props: any): any => config(props).media.md`
    padding: 0;
    background: url('/images/Voice-Actor-Dusk.jpg') no-repeat;
  `}
`

const TakeAListenContainer = styled.main<any>`
  background: url('/images/Voice-Actor-Dawn-Mobile.jpg') no-repeat;
  background-size: cover;
  background-color: ${colors.cobalt};
  padding: 30px 0 65px;
  overflow: hidden;
  ${(props: any): any => config(props).media.md`
    padding: 52px 0 84px;
    background: url('/images/Voice-Actor-Dawn.jpg') no-repeat;
  `}
  ${(props: any): any => config(props).media.lg`
    padding: 98px 0 100px;
  `}
  ${(props: any): any => config(props).media.xl`
    padding: 120px 0 100px;
    > div {
      max-width: 1350px;
    }
  `}
`

const TitleH1 = styled(H1)<any>`
  color: ${colors.sand};
  margin-top: 48px;
  margin-bottom: 20px;
  ${(props: any): any => config(props).media.sm`
    margin-top: 90px;
  `}
  ${(props: any): any => config(props).media.md`
    margin-top: 76px;
  `}
  ${(props: any): any => config(props).media.lg`
    margin-top: 120px;
    font-size: 90px;
    line-height: 105%;
  `}
  ${(props: any): any => config(props).media.xl`
    margin-top: 138px;
  `}
`

const VoiceH2 = styled(H2)<any>`
  font-size: 36px;
  line-height: 120%;
  ${(props: any): any => config(props).media.lg`
    font-size: 45px;
    line-height: 120%;
  `}

`
const VoiceH2a = styled(H2)<any>`
  font-size: 36px;
  line-height: 120%;
  text-align: left;
  margin-bottom: 20px;
  ${(props: any): any => config(props).media.md`
    text-align: center;
  `}
  ${(props: any): any => config(props).media.lg`
    text-align: left;
    font-size: 45px;
    line-height: 120%;
    margin-bottom: 16px;
  `}
`

const Description = styled(P)<any>`
  color: ${colors.sand};
  max-width: 335px;
  margin: 0 auto 30px;
  text-align: left;
  font-size: 16px;
  line-height: 150%;
  ${(props: any): any => config(props).media.sm`
    max-width: 464px;
  `}
  ${(props: any): any => config(props).media.md`
    max-width: 450px;
    text-align: center;
  `}
  ${(props: any): any => config(props).media.lg`
    max-width: 820px;
    margin-bottom: 34px;
    font-size: 18px;
    line-height: 150%;
  `}
  ${(props: any): any => config(props).media.xl`
    max-width: 862px;
  `}
`
const Description2 = styled(Description)<any>`
  margin-bottom: 38px;
  ${(props: any): any => config(props).media.lg`
    text-align: left;
    margin-bottom: 40px;
  `}
`
const DescriptionWithDots = styled(Description)<any>`
  margin: 0 auto 28px;
  max-width: 300px;
  ${(props: any): any => config(props).media.md`
    max-width: 400px;
    margin: 0 auto 30px;
    text-align: left;
  `}
  ${(props: any): any => config(props).media.lg`
    margin: 0 auto 34px;  
  `}
`
const AuditionBtnContainer = styled.div<any>`
  box-sizing: border-box;
  max-width: 232px;
  margin: 0 auto 72px;
  ${(props: any): any => config(props).media.md`
    margin-bottom: 90px;
  `}
  ${(props: any): any => config(props).media.lg`
    margin-bottom: 100px;
  `}
  ${(props: any): any => config(props).media.xl`
    margin-bottom: 134px;
  `}
`
const AuditionBtnContainer2 = styled(AuditionBtnContainer)<any>`
  ${(props: any): any => config(props).media.md`
    margin-bottom: 112px;
  `}
  ${(props: any): any => config(props).media.lg`
    margin-bottom: 100px;
  `}
  ${(props: any): any => config(props).media.xl`
    margin-bottom: 120px;
  `}
`

const TrackTextContainer = styled.div<any>`
  margin: 40px 0 10px;
  ${(props: any): any => config(props).media.md`
    text-align: center;
    margin: 40px 0 6px;
  `}
  ${(props: any): any => config(props).media.lg`
    text-align: left;
    margin: 118px 0 6px;
  `}
  ${(props: any): any => config(props).media.xl`
    margin: 143px 0 6px 74px;
  `}
`
const TrackTextButton = styled.a<any>`
  font-family: 'Good Sans Regular';
  text-transform: uppercase;
  background: transparent;
  outline: none;
  border: 1px solid ${colors.sand};
  border-radius: 32px;
  padding: 10px 83px;
  color: ${colors.sand};
  font-size: 12px;
  line-height: 14px;
  text-decoration: none;
  letter-spacing: 0.5px;
  ${(props: any): any => config(props).media.md`
    padding: 11px 60px;
  `}
  ${(props: any): any => config(props).media.lg`
    padding: 12px 86px;
  `}
`
const SliderWrapper = styled.div<any>`
  margin-bottom: 8px;
  ${(props: any): any => config(props).media.md`
    margin-bottom: 96px;
  `}
`
